import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { MspInProductTrialsOverlayWindowsAppDataProviderFactory } from '../factory/MspInProductTrialsOverlayWindowsAppDataProviderFactory';
import { MspInProductTrialsOverlayWindowsAppBaseDataProvider } from '../dataProvider/MspInProductTrialsOverlayWindowsAppBaseDataProvider';
import { MspInProductTrialsAdditionalUserSettings } from '../view/configs/msp-in-product-trials-overlay-window-config';

export class MspInProductTrialsOverlayWindowsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MspInProductTrialsOverlayWindowsAppDataProviderFactory;
  public dataProvider: MspInProductTrialsOverlayWindowsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MspInProductTrialsOverlayWindowsAppDataProviderFactory(),
    });
  }

  public async getAdditionalUserSettingsForInProductTrials(): Promise<MspInProductTrialsAdditionalUserSettings> {
    return this.dataProvider.getAdditionalUserSettingsForMspInProductTrials();
  }
}
